import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'safeHtml', standalone: true })
export class SafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(htmlContent: string): SafeHtml {
    console.log(htmlContent);
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }
}
